/* SETTINGS */
export const CHANGE_LOCALE = 'CHANGE_LOCALE';

/* AUTH */
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const LOGOUT_USER = 'LOGOUT_USER';

/* MENU */
export const MENU_SET_CLASSNAMES = 'MENU_SET_CLASSNAMES';
export const MENU_CONTAINER_ADD_CLASSNAME = 'MENU_CONTAINER_ADD_CLASSNAME';
export const MENU_CLICK_MOBILE_MENU = 'MENU_CLICK_MOBILE_MENU';
export const MENU_CHANGE_DEFAULT_CLASSES = 'MENU_CHANGE_DEFAULT_CLASSES';
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS = 'MENU_CHANGE_HAS_SUB_ITEM_STATUS';


/* PRESENTATIONS */
export const TOGGLE_ALL_PRESENTATION = 'TOGGLE_ALL_PRESENTATION';
export const TOGGLE_SELECT_PRESENTATION = 'TOGGLE_SELECT_PRESENTATION';
export const SET_PRESENTATION_LIST = 'SET_PRESENTATION_LIST';
export const RESET_PRESENTATION_LIST = 'RESET_PRESENTATION_LIST';
export const TOGGLE_SELECT_RENDER_PRODUCT = 'TOGGLE_SELECT_RENDER_PRODUCT';
export const RESET_SELECTED_RENDER_PRODUCT = 'RESET_SELECTED_RENDER_PRODUCT';
export const UPDATE_SELECTED_RENDER_PRODUCT = 'UPDATE_SELECTED_RENDER_PRODUCT';

